module.exports = __webpack_public_path__ + "static/media/syn-myndlykill-1920x1080.b8bf480f.jpg";